import { useProfile } from "Components/Hooks/UserHooks";
import { isAllowed } from "common/lib/permissionUtils";
import {
  addPseaAssessment,
  addAgencyPseaAssessment,
} from "common/services/psea-assessments.service";

/**
 * Resolves whether the current user can create a PSEA assessment and which
 * endpoint to use. Mirrors `usePseaUpdater`: a user may hold either the main
 * API create permission (`psea-assessment` controller) or the agency create
 * permission (`agency` controller). The main API takes precedence when both
 * are present.
 */
export const usePseaCreator = () => {
  const { userProfile } = useProfile();
  const permissions = userProfile?.permissions;

  const canCreateMain = isAllowed(permissions, [
    { resource: "psea-assessment", action: "create" },
  ]);
  const canCreateAgency = isAllowed(permissions, [
    { resource: "psea-assessment", action: "create", controller: "agency" },
  ]);

  const canCreate = canCreateMain || canCreateAgency;

  const create = canCreateMain
    ? addPseaAssessment
    : canCreateAgency
    ? addAgencyPseaAssessment
    : null;

  return { canCreate, create };
};
